<template>
<form @submit.prevent="validateFields(formScope)" :data-vv-scope="formScope" class="ui large form">
	<div class="two fields">
		<div class="field required" :class="{ 'error' : errors.has(formScope + '.firstname')}">
			<label for="firstname">{{ $t('pages.setup.form.firstname') }}</label>
			<div class="ui input corner labeled">
				<input type="text" v-model="form.firstname" name="firstname" v-validate="'required'">

				<div class="ui corner label">
					<i class="asterisk icon"/>
				</div>
			</div>
			<span style="color:red;" v-if="errors.has(formScope + '.firstname')">{{ errors.first(formScope + '.firstname') }}</span>
		</div>

		<div class="field required" :class="{ 'error' : errors.has(formScope + '.lastname')}">
			<label for="lastname">{{ $t('pages.setup.form.lastname') }}</label>
			<div class="ui input corner labeled">
				<input type="text" v-model="form.surname" name="lastname" v-validate="'required'">
				<div class="ui corner label">
					<i class="asterisk icon"/>
				</div>
			</div>
			<span style="color:red;" v-if="errors.has(formScope + '.lastname')">{{ errors.first(formScope + '.lastname') }}</span>
		</div>
	</div>

	<div class="three fields" v-for="(field, index) in chunkProperty(userFields.slice(0, 3), 3)" :key="'A' + index">
		<field :field="field[0]" :scope="formScope" @input="changeFieldValue" :transparent="false" :allowEdit="true" v-if="field[0]"/>
		<field :field="field[1]" :scope="formScope" @input="changeFieldValue" :transparent="false" :allowEdit="true" v-if="field[1]"/>
		<field :field="field[2]" :scope="formScope" @input="changeFieldValue" :transparent="false" :allowEdit="true" v-if="field[2]"/>
	</div>
	<div class="two fields" v-for="(field, index) in chunkProperty(userFields.slice(3), 2)" :key="'B' + index">
		<field :field="field[0]" :scope="formScope" @input="changeFieldValue" :transparent="false" :allowEdit="true" v-if="field[0]"/>
		<field :field="field[1]" :scope="formScope" @input="changeFieldValue" :transparent="false" :allowEdit="true" v-if="field[1]"/>
	</div>
</form>
</template>

<script>
	import chunk from 'lodash/chunk'
	import find from 'lodash/find'

	export default {
		name: 'ProfileSetup',

		data () {
			return {
				formScope: 'profile-setup',

				form: {
					firstname: this.$auth.user().firstname ? this.$auth.user().firstname : '',
					surname: this.$auth.user().surname ? this.$auth.user().surname : ''
				},

				userFields: [],

				fieldValues: []
			}
		},

		mounted () {
			this.fetchUserFields(foundFields => {
				this.userFields = foundFields
			})
		},

		methods: {
			chunkProperty (property, chunkSize) {
				return chunk(property, chunkSize)
			},

			fetchUserFields () {
				return new Promise((resolve, reject) => {
					var foundFields = this.$auth.user().fields.filter((currentValue, index, arary) => {
						if (currentValue.shown === 'both' || currentValue.shown === 'individual') {
							return currentValue
						}
					})
					this.userFields = foundFields
					resolve(foundFields)
				})
			},

			validateFields (formScope) {
				return new Promise((resolve, reject) => {
					this.$validator.validateAll(formScope)
						.then(result => {
							if (result) {
								if (this.fieldValues.length > 0 || this.form.firstname !== this.$auth.user().firstname || this.form.surname !== this.$auth.user().surname) {
									var fields = []
									// handle editableFields
									$.map(this.fieldValues, function (item, index) {
										if (item.editable) {
											if (item.required) {
												if (item.value !== '') {
													fields.push({ id: item.id, value: item.value })
												}
											} else {
												if (item.value === '') {
													fields.push({ id: item.id, value: null })
												} else {
													fields.push({ id: item.id, value: item.value })
												}
											}
										}
									})

									this.axios.put('users', {
										firstname: this.form.firstname,
										surname: this.form.surname,
										fields: fields
									})
									.then(() => {
										this.$auth.fetch()

										this.$events.$emit('alert', {
											header: this.$t('globals.validation.success.success'),
											message: this.$t('pages.setup.validation.success.user_success'),
											type: 'success',
											closebutton: true,
											align: 'right'
										})

										resolve(true)
									}).catch(() => {
										reject()
									})
								} else {
									resolve(true)
								}
							}
						}).catch()
				})
			},

			changeFieldValue (field) {
				if (!find(this.fieldValues, {id: field.id})) {
					this.fieldValues.push(field)
				} else {
					var arrayValue = find(this.fieldValues, {id: field.id})
					arrayValue.value = field.value
				}
			}
		}
	}
</script>




// WEBPACK FOOTER //
// src/components/pages/setup/ProfileSetup.vue